<template>
  <button 
    :is="elType"
    class="agenda__item-calendar-links-button" 
    @click="clicked"
    :class="{
      'is-before-start' : isBeforeStart,
      'is-after-end' : isAfterEnd,
      'is-live' : isLive
    }"
    v-show="agendaItem.add_to_calendar_link"
    >
    <slot name = "text">
      <i class="agenda__item-icon agenda__calendar-icon far fa-calendar-plus"></i>
      {{text || lang.get('event_strings.agenda.add_to_calendar')}}
    </slot>
  </button>
</template>

<script>
  export default {
    data() {
      return {
        isBeforeStart: true,
        isAfterEnd: false,
        isLive: false,
      }
    },
    props: {
      elType: {
        type: String,
        default: "button"
      },
      text: {
        type: String,
        default: ""
      },
      agendaItem: {
        type: Object,
        required: true,
      },
      event: {
        type: Object,
        required: true
      },
      targetKey: {
        type: [String, Number],
        default: 1
      }
    },
    computed: {
    },  
    methods: {
      clicked() {
        this.$emit('click');
        EventBus.$emit(`openAddToCalendarModal-${this.targetKey}`, {
          agendaItem: this.agendaItem,
          event: this.event
        })
      },
      calculateVisibility(){
        const eventTz = this.event.timezone;
        const agendaItemStart = moment.tz(this.agendaItem.start_datetime, eventTz);
        const agendaItemEnd = moment.tz(this.agendaItem.end_datetime, eventTz);
        const currentTime = moment.tz(moment.tz.guess());
        this.isBeforeStart = currentTime.isBefore(agendaItemStart);
        this.isAfterEnd = currentTime.isAfter(agendaItemEnd);
        this.isLive = currentTime.isBetween(agendaItemStart, agendaItemEnd);
      },
      
    },
    created() {
      this.$nextTick(()=>{
        this.calculateVisibility();
      })
    }
    // mounted () {
      // EventBus.$on('hide', () => {
      //   this.show = false
      // });
      // EventBus.$on('show', () => {
      //   this.show = show
      // });
    // },
  }
</script>

<style scoped>
.is-after-end {
  display: none;
}
.is-live {
  display: none;
}
.agenda__item-calendar-links-button {
  padding: 0;
}
.baseEvent .agenda__item-calendar-links-button,
.baseEvent .agenda__item-calendar-links-button i {
  text-decoration: none;
  color: var(--theme-secondary-color);
}
</style>